import { Cloud } from "lucide-react";
import { MetricWidget } from "@/components/custom/widgets/metric-widget";
import { useGetServers } from "../../../servers/api/hooks";

export function ServersMetric() {
  const { data: serversCount = 0 } = useGetServers<number>("project", {
    select: (servers) => servers?.length ?? 0,
  });

  return (
    <MetricWidget
      href="/orgs/$organizationId/projects/$projectId/servers"
      icon={Cloud}
      title="Servers"
      value={serversCount}
    />
  );
}
